module.exports = __webpack_public_path__ + "static/media/search_slider_phone3.bab5d095.png";